import React, { useState } from "react";
import { Mensaje } from "../mensajes";

export const TimbreActu = () => {
  const op = require("../../../public/modulos/datos");
  const [status, setStatus] = useState(false);
  const [socket, setSocket] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const sincronizar = () => {
    let sock = new WebSocket(op.timbreactu);
    sock.onmessage = (event) => {
      document.getElementById("line").innerHTML += `<p>${event.data}</p>`;
    };

    sock.onopen = () => {
      document.getElementById("line").innerHTML = "";
      sock.send(JSON.stringify("sincronizar"));
    };

    /*     sock.onclose = () => {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Proceso Cancelado",
        icono: "informacion",
      });
    }; */

    setSocket(sock);

    setStatus(true);
  };

  const cancelar = () => {
    socket.close();
    document.getElementById("line").innerHTML = "";
    setStatus(false);
  };

  return (
    <div className="card">
      <div
        style={{
          padding: 20,
          margin: "auto",
          height: "80vh",
          width: "90%",
          overFlow: "auto",
        }}
      >
        <button
          className="btn btn-info m-1"
          disabled={status}
          onClick={sincronizar}
        >
          <i className="fas fa-sync"> Sincronizar</i>
        </button>
        <button
          className="btn btn-secondary m-1"
          disabled={!status}
          onClick={cancelar}
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
        <div
          id="app"
          style={{
            width: "100%",
            height: "70vh",
            paddingBottom: 100,
          }}
        >
          <div id="terminal">
            <div className="history">
              <div
                id="line"
                style={{ color: "#FFFFFF" }}
                className="line"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/TimbreActu.js